<script setup lang="ts">
  defineProps({
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    bgColor: {
      type: String,
      default: null,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    classInner: {
      type: String,
      default: null,
    },
    position: {
      type: String,
      default: 'center',
    },
    isWidthUnset: {
      type: Boolean,
      default: false,
    },
  })
</script>
<template>
  <div class="bh-card" :style="{ justifyContent: position ? position : '' }">
    <div
      class="w-100"
      :class="{
        'no-box-shadow': flat,
        'bh-card-inner': !classInner,
        'width-unset': isWidthUnset,
        [classInner]: classInner,
      }"
      :style="{
        maxWidth: width ? `${width}px` : '100%',
        minHeight: height ? `${height}px` : '',
        backgroundColor: bgColor,
      }"
    >
      <slot />
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .bh-card {
    display: flex;
    align-items: center;

    &-inner {
      box-shadow: 0 0 15px #95959570;
      border-radius: 16px;
      padding: 16px;

      @media (max-width: 768px) {
        padding: 15px;
      }
      &.no-box-shadow {
        box-shadow: none;
      }
      &.width-unset {
        width: unset;
      }
    }

    &-simple {
      padding: 15px 20px;

      @media (max-width: 768px) {
        padding: 15px;
      }
    }

    &-no-padding {
      padding: 0;
    }

    &-login {
      box-shadow: 0 0 15px #95959570;
      &.no-box-shadow {
        box-shadow: none;
      }
    }

    &.with-tab {
      .bh-card-inner {
        border-top-left-radius: 0;
        padding: 25px;
        @media (max-width: 600px) {
          padding: 15px 10px;
        }
      }
    }

    &-without-border-radius {
      border-radius: unset;
      padding: 16px;
    }
  }
</style>
